// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 644 ? "3b1baa31" : chunkId) + "." + {"342":"e1aa71771eb1dfa3","644":"b5619f1325f64ab5","656":"524d8898cb602af5","817":"e8010dcbedeeef6a"}[chunkId] + ".js";
};